import { render, staticRenderFns } from "./HomeworksDesktop.vue?vue&type=template&id=d5206c44&"
import script from "./HomeworksDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeworksDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports